module.exports = __webpack_public_path__ + "img/toplogo.9c6b3d44.png";